<script>
  import TestimonialCard from '$lib/TestimonialCard.svelte'
  import { fade } from 'svelte/transition'
</script>

<section class="py-4">
  <div class="container mx-auto px-4 flex justify-center w-full">
    <TestimonialCard
        image="/resocialize-carl.png"
        alt="CEO of Resocialize"
        quote="AddMeetings helped me break into a market I'd tried and failed repeatedly in. I've been selling outbound for years and still wasn't cracking the market. Not only did I get meetings with my ICP, but they were also highly relevant and turned into solid opportunities without any noise."
        name="Carl Wilhelm Hagander"  
        designation="Co-Founder of ReSocialize"
      />
  </div>
</section>
